import * as A from '../admin'

export const FooterAdmin = () => (
  <p>
    Footer is configured globally in <A.NavOut tab="Design" subtab="nav" />.
  </p>
)

export interface FooterBlockGlobalConfig extends A.GlobalBlockConfig {
  alignment: 'center' | 'left' | 'right'
  showSiteAdminLink: boolean
  links: Array<{text: string; link: string}>
  copyright: string
}

export const defaultGlobalConfig: FooterBlockGlobalConfig = {
  alignment: 'center',
  showSiteAdminLink: true,
  links: [
    {text: 'Privacy', link: '/privacy'},
    {text: 'Terms of Use', link: '/terms'},
  ],
  copyright: '',
  FREEMARKER: {
    copyright: 'html',
  },
}

export const globalMigrate: A.GlobalMigrate<FooterBlockGlobalConfig> = ({
  defaultGlobalMigrate,
  globalConfig: unknownGlobalConfig,
  ...props
}) => {
  let globalConfig = {
    ...(unknownGlobalConfig as any),
  } as Partial<FooterBlockGlobalConfig>

  // Migrate from (really old) static four links to dynamic.
  if (!globalConfig.links) {
    const {text0, link0, text1, link1, text2, link2, text3, link3, ...rest} =
      globalConfig as any
    globalConfig = {
      ...rest,
      links: [
        {text: text0, link: link0},
        {text: text1, link: link1},
        {text: text2, link: link2},
        {text: text3, link: link3},
      ],
    }
  }

  return defaultGlobalMigrate({...props, globalConfig})
}

export const FooterGlobalAdmin: A.Admin<FooterBlockGlobalConfig> = () => {
  return (
    <>
      <A.Group>
        <A.CheckRight
          label="Include link to site admin"
          name="showSiteAdminLink"
        />
      </A.Group>
      <A.Group title="Links">
        <A.FieldArray name="links">
          {({fields}) => (
            <div>
              {fields.map((name, i) => (
                <A.SubGroup key={name}>
                  <A.Input label="Nav Item" name={`${name}.text`} />
                  <A.Input label="URL" name={`${name}.link`} />
                  <A.Button onClick={() => fields.remove(i)}>Remove</A.Button>
                </A.SubGroup>
              ))}
              <A.Button onClick={() => fields.push({text: '', link: '/'})}>
                Add
              </A.Button>
            </div>
          )}
        </A.FieldArray>
      </A.Group>
      <A.Group title="Appearance">
        <A.Radio
          label="Alignment"
          name="alignment"
          options={A.options({
            left: 'Left aligned',
            center: 'Centered',
            right: 'Right aligned',
          })}
        />
      </A.Group>
      <A.Group>
        <A.Input label="Copyright" name="copyright" />
      </A.Group>
    </>
  )
}
